import { useEffect } from 'react';
import { useNavigate } from 'react-router';
import { MarketGroup } from '../@types';

type UseMarketGroupNavigationParams = {
  marketGroupId?: string;
  marketGroups?: MarketGroup[];
};

export const useMarketGroupNavigation = ({ marketGroupId, marketGroups }: UseMarketGroupNavigationParams) => {
  const navigate = useNavigate();

  useEffect(() => {
    if (!marketGroupId && marketGroups !== undefined) {
      if (marketGroups.length > 0) {
        navigate(`./${marketGroups[0].id}`, { replace: true });
      } else {
        navigate('./all', { replace: true });
      }
    }
  }, [marketGroupId, marketGroups, navigate]);
};
